export default (values: Record<string, any>) => {
  const errors: Record<string, any> = {};

  if ((!values?.text || values.text.length === 0) && !values?.attachment) errors.text = true;

  return errors;
};
